import React, { useEffect } from 'react';
import { useOrderContext } from '../context/OrderContext';
import Hero from '../components/Hero';
import { formatPrice } from '../utils/helper';

function Orders() {
  const { orders, getOrderByUserId } = useOrderContext();

  useEffect(() => {
    getOrderByUserId();
  }, []);

  return (

    <div className="bg-[#fef8f5]">
  <Hero
    title={"Orders"}
    description={"This is your order summary"}
    image={
      "https://www.astronauts.id/blog/wp-content/uploads/2022/08/Rekomendasi-Produk-Skincare-untuk-Pemula-yang-Wajib-Kamu-Miliki-1024x683.jpg"
    }
  />

  <div className="max-w-7xl mx-auto px-4 py-16">
    <h2 className="text-2xl font-bold text-[#7a6e5f] mb-6">Your Orders</h2>

    <table className="w-full text-left text-sm border-collapse">
      <thead className="bg-[#f5eee6] text-[#7a6e5f]">
        <tr>
          <th className="px-4 py-2">Order ID</th>
          <th className="px-4 py-2">Items</th>
          <th className="px-4 py-2">Total</th>
          <th className="px-4 py-2">Status</th>
        </tr>
      </thead>
      <tbody>
        {orders.map((order) => (
          <tr key={order.id} className="border-b">
            <td className="px-4 py-2">{order.id}</td>
            <td className="px-4 py-2 space-y-1">
              {order.order_items?.map((item) => (
                <div key={item.id}>
                  {item.product_variant?.variant_name || "Variant"} × {item.quantity}
                </div>
              ))}
            </td>
            <td className="px-4 py-2">Rp{order.total.toLocaleString("id-ID")}</td>
            <td className="px-4 py-2 capitalize">{order.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

  );
}

export default Orders;